import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/edit-login-key-dialog.hbs';

var alertCh = Radio.channel('alerts');

var success_tmpl = Handlebars.compile('Successfully updated login key {{id}}.');
var MAX_DESCRIPTION_LENGTH = 300;

var View = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(template),
    ui: {
        form: 'form',
        submit: 'button.submit',
        current_password: '#current-password',
        description: '.description',
        description_length_counter: '.description-counter',
    },
    events: {
        'submit @ui.form': 'on_submit',
        'keyup @ui.description': 'validate',
        'keyup @ui.current_password': 'validatePassword',
    },
    initialize: function () {
        this.destroyOnClose();
        _.bindAll(this, 'on_success', 'error');
    },
    onRender: function(){
        this.validate();
    },
    validate: function() {
        this.validateDescription();
        this.validatePassword();
    },
    validatePassword: function() {
        if (this.ui.current_password.val() && this.ui.current_password.val().length > 8) {
            this.ui.submit.prop('disabled', false);
        } else {
            this.ui.submit.prop('disabled', true);
        }
    },
    validateDescription: function () {
        if (this.ui.description.val()) {
            this.check_validation(
                this.ui.description,
                MAX_DESCRIPTION_LENGTH,
                this.ui.description_length_counter,
                this.ui.submit
            );
        } else {
            this.check_validation(
                this.ui.description,
                MAX_DESCRIPTION_LENGTH,
                this.ui.description_length_counter,
                this.ui.submit
            );
            this.ui.submit.prop('disabled', true);
        }
    },
    /**
     * Handle a form submission
     *
     * @param DOMEvent
     */
    on_submit: function (e) {
        e.preventDefault();
        var current_password = this.ui.current_password.val();
        var options = {
            success: this.on_success,
            error: this.error
        };

        this.model.update(current_password, {description: this.ui.description.val()}, options).done();
    },
    on_success: function (model, response) {
        alertCh.request('showAlert', {
            message: success_tmpl({ id: model.id }),
            messageType: 'success'
        });
        this.closeDialog();
    },
    error: function (model, error) {
        var err_string = error.responseJSON.errors[0].detail;
        DialogInterface.showAlert.call(this, 'alert-danger', err_string);
    },
});
export default View;

